import { api } from './client'
import type {
  ApiSalesLead,
  AssignSalesManagerRequest,
  AssignSalesRepRequest,
  ChangeDepartmentRequest,
  SearchSalesLeadRequest,
} from './types'

// All endpoints are scoped under /v1/sales/:teamId/leads. Mirrors
// etx/server/src/sales-funnel/sales.controller.ts.
//
// Auth surface (per controller):
//   • All endpoints: Director / GM-group / GM-dealer / SM / SR
//   • assignToSalesManager: dealership GM only (no parent-group fallthrough)
//   • assignToSalesRep:     dealership SM only
// The FE gates these buttons before calling, but the BE is authoritative.
export const salesLeadsApi = {
  // BE validates `page` with @Min(1); clamp client-side so 0-indexed
  // callers don't 400 the request before pagination kicks in.
  list: (teamId: number | string, page: number = 1) =>
    api.get<ApiSalesLead[]>(`/sales/${teamId}/leads`, { page: Math.max(1, Math.floor(page)) }),

  pending: (teamId: number | string) =>
    api.get<ApiSalesLead[]>(`/sales/${teamId}/leads/pending`),

  assigned: (teamId: number | string) =>
    api.get<ApiSalesLead[]>(`/sales/${teamId}/leads/assigned`),

  search: (teamId: number | string, data: SearchSalesLeadRequest) =>
    api.post<ApiSalesLead[]>(`/sales/${teamId}/leads/search`, data),

  get: (teamId: number | string, leadId: number | string) =>
    api.get<ApiSalesLead>(`/sales/${teamId}/leads/${leadId}`),

  changeDepartment: (
    teamId: number | string,
    leadId: number | string,
    data: ChangeDepartmentRequest,
  ) =>
    api.patch<ApiSalesLead>(`/sales/${teamId}/leads/${leadId}/department`, data),

  assignSalesManager: (
    teamId: number | string,
    leadId: number | string,
    data: AssignSalesManagerRequest,
  ) =>
    api.post<ApiSalesLead>(`/sales/${teamId}/leads/${leadId}/sales-manager`, data),

  assignSalesRep: (
    teamId: number | string,
    leadId: number | string,
    data: AssignSalesRepRequest,
  ) =>
    api.post<ApiSalesLead>(`/sales/${teamId}/leads/${leadId}/sales-rep`, data),
}
